if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"portal_vela","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return /^(1(09[14]|4(13|51|98)|340|575|636|699|741|916)|2(1(1|53|59)|2(32|70|86)|5(01|1|50|66)|02|094|321|384|456|698|75)|3(071|170|289|433|517|643|744|814)|4(8(60|66|9)|117|172|31|336|722|987)|5((03|27|84)3|[28]37|028|119|415|54|640|70)|6((27|48|93)0|388|429|575|624|677)|7(7(16|28|92)|0|054|178|505|527|672|852|947)|8(048|186|39|540|592|81|849)|9372|9404)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}